import { logoDT, logoCE, logoSelo, logoAT, logoGOV } from "./logosSistemas";
import titulos from "./titleSistema";

/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
  na: true,
  uf: "RJ",
  isIndicadores: false,
  isSala: false,
  isParceiro: false,
  isAT: false,
};

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
  //DEV
  { tag: "amazonaws.com", uf: "SC" },
  {
    tag: "dev-2025.cidade",
    uf: "SC",
    env: process.env.VUE_APP_BASE_API_2025_CE_DEV,
  },

  { tag: "dev.cidade", uf: "SC" },
  { tag: "dev.selo", banco: "selo-dev", uf: "AL" },
  {
    tag: "dev-2025.sistema",
    uf: "AL",
    banco: "selo-dev",
    env: process.env.VUE_APP_BASE_API_2025_CE_DEV,
  },

  { tag: "dev.sistema", banco: "selo-dev", uf: "AL" },
  { tag: "dev.agentesterritoriais", banco: "at-dev", uf: "RJ" },
  { tag: "dev.governancaempreendedora", banco: "gov-dev", uf: "PE" },
  { tag: "dev-governancaempreendedora", banco: "gov-dev", uf: "PE" },

  { tag: "dev-cidade", uf: "SC" },
  { tag: "dev-selo", banco: "selo-dev", uf: "AL" },
  { tag: "dev-agentesterritoriais", banco: "at-dev", uf: "RJ" },
  {
    tag: "dev.desenvolvimentoterritorial",
    banco: "ce-dev",
    uf: "DF",
    isDT: true,
  },

  //HLG
  { tag: "hlg-parceiros.sistemaselo", banco: "selo-dev-parceiros", uf: "PE" },
  { tag: "hlg-parceiros-sistemaselo", banco: "selo-dev-parceiros", uf: "PE" },
  { tag: "hlg-cidade", uf: "PR" },
  { tag: "hlg.cidade", uf: "PR" },
  { tag: "hlg.selo", banco: "selo-hlg", uf: "RJ" },
  { tag: "hlg.sistemaselo", banco: "selo-hlg", uf: "RJ" },
  {
    tag: "hlg.desenvolvimentoterritorial",
    banco: "ce-hlg",
    uf: "DF",
    isDT: true,
  },
  { tag: "hlg-selo", banco: "selo-hlg", uf: "RJ" },
  { tag: "pe-hlg.agentesterritoriais", banco: "at-pe-hlg", uf: "PE" },
  { tag: "hlg.agentesterritoriais", banco: "at-hlg", uf: "RJ" },
  { tag: "hlg-agentesterritoriais", banco: "at-hlg", uf: "RJ" },
  { tag: "hlg-2025.cidade", banco: "ce-hlg", uf: "RJ" },

  { tag: "sp-hlg", uf: "SP", banco: "ce-sp-hlg" },
  { tag: "sc-hlg", uf: "SC", banco: "ce-sc-hlg" },
  { tag: "ms-hlg", uf: "MS", banco: "ce-ms-hlg" },
  { tag: "es-hlg", uf: "ES", banco: "ce-es-hlg" },
  { tag: "al-hlg", uf: "AL", banco: "ce-al-hlg" },
  { tag: "ma-hlg", uf: "MA", banco: "ce-ma-hlg" },
  { tag: "ap-hlg", uf: "AP", banco: "ce-ap-hlg" },
  { tag: "ba-hlg", uf: "BA", banco: "ce-ba-hlg" },
  { tag: "rj-hlg", uf: "RJ", banco: "ce-rj-hlg" },
  { tag: "ac-hlg", uf: "AC", banco: "ce-ac-hlg" },
  { tag: "am-hlg", uf: "AM", banco: "ce-am-hlg" },
  { tag: "ce-hlg", uf: "CE", banco: "ce-ce-hlg" },
  { tag: "go-hlg", uf: "GO", banco: "ce-go-hlg" },
  { tag: "mt-hlg", uf: "MT", banco: "ce-mt-hlg" },
  { tag: "mg-hlg", uf: "MG", banco: "ce-mg-hlg" },
  { tag: "pa-hlg", uf: "PA", banco: "ce-pa-hlg" },
  { tag: "pb-hlg", uf: "PB", banco: "ce-pb-hlg" },
  { tag: "pr-hlg", uf: "PR", banco: "ce-pr-hlg" },
  { tag: "pe-hlg", uf: "PE", banco: "ce-pe-hlg" },
  { tag: "pi-hlg", uf: "PI", banco: "ce-pi-hlg" },
  { tag: "rn-hlg", uf: "RN", banco: "ce-rn-hlg" },
  { tag: "rs-hlg", uf: "RS", banco: "ce-rs-hlg" },
  { tag: "ro-hlg", uf: "RO", banco: "ce-ro-hlg" },
  { tag: "rr-hlg", uf: "RR", banco: "ce-rr-hlg" },
  { tag: "se-hlg", uf: "SE", banco: "ce-se-hlg" },
  { tag: "to-hlg", uf: "TO", banco: "ce-to-hlg" },
  { tag: "df-hlg", uf: "DF", banco: "ce-df-hlg" },

  // PROD
  { tag: "ac.", banco: "ac", uf: "AC" },
  { tag: "ms.", banco: "ms", uf: "MS" },
  { tag: "al.", banco: "al", uf: "AL" },
  { tag: "ma.", banco: "ma", uf: "MA" },
  { tag: "rj.", banco: "rj", uf: "RJ" },
  { tag: "sp.", banco: "sp", uf: "SP" },
  { tag: "es.", banco: "es", uf: "ES" },
  { tag: "ba.cidade", banco: "ba", uf: "BA" },
  { tag: "sc.", banco: "sc", uf: "SC" },
  { tag: "ap.", banco: "ap", uf: "AP" },
  { tag: "am.", banco: "am", uf: "AM" },
  { tag: "ce.", banco: "ce", uf: "CE" },
  { tag: "go.", banco: "go", uf: "GO" },
  { tag: "mt.", banco: "mt", uf: "MT" },
  { tag: "pa.", banco: "pa", uf: "PA" },
  { tag: "pb.", banco: "pb", uf: "PB" },
  { tag: "pr.", banco: "pr", uf: "PR" },
  { tag: "pe.", banco: "pe", uf: "PE" },
  { tag: "pi.", banco: "pi", uf: "PI" },
  { tag: "rn.", banco: "rn", uf: "RN" },
  { tag: "mg.", banco: "mg", uf: "MG" },
  { tag: "rs.", banco: "rs", uf: "RS" },
  { tag: "ro.", banco: "ro", uf: "RO" },
  { tag: "rr.", banco: "rr", uf: "RR" },
  { tag: "se.", banco: "se", uf: "SE" },
  { tag: "to.", banco: "to", uf: "TO" },
  { tag: "df.", banco: "df", uf: "DF" },
  { tag: "na.", banco: "na", uf: "NA" },
  {
    tag: "sc-2022",
    env: process.env.VUE_APP_BASE_API_SC_2022,
    banco: "cidade-empreendedora-sc-2022",
    uf: "SC",
  },
  {
    tag: "indicadores-sp",
    banco: "cidade-empreendedora-sp-indicadores",
    uf: "SP",
    isIndicadores: true,
  },
  { tag: "indicadores.consorcioempreendedor", banco: "sp", uf: "SP" },
  // selo
  { tag: "rj.selo", banco: "selo-sala-rj", uf: "RJ" },
  { tag: "al.selo", banco: "selo-sala-al", uf: "AL" },
  { tag: "ac.selo", banco: "selo-sala-ac", uf: "AC" },
  { tag: "ms.selo", banco: "selo-sala-ms", uf: "MS" },
  { tag: "ma.selo", banco: "selo-sala-ma", uf: "MA" },
  { tag: "sp.selo", banco: "selo-sala-sp", uf: "SP" },
  { tag: "es.selo", banco: "selo-sala-es", uf: "ES" },
  { tag: "ba.selo", banco: "selo-sala-ba", uf: "BA" },
  { tag: "sc.selo", banco: "selo-sala-sc", uf: "SC" },
  { tag: "ap.selo", banco: "selo-sala-ap", uf: "AP" },
  { tag: "am.selo", banco: "selo-sala-am", uf: "AM" },
  { tag: "ce.selo", banco: "selo-sala-ce", uf: "CE" },
  { tag: "go.selo", banco: "selo-sala-go", uf: "GO" },
  { tag: "mt.selo", banco: "selo-sala-mt", uf: "MT" },
  { tag: "pa.selo", banco: "selo-sala-pa", uf: "PA" },
  { tag: "pb.selo", banco: "selo-sala-pb", uf: "PB" },
  { tag: "pr.selo", banco: "selo-sala-pr", uf: "PR" },
  { tag: "pe.selo", banco: "selo-sala-pe", uf: "PE" },
  { tag: "pi.selo", banco: "selo-sala-pi", uf: "PI" },
  { tag: "rn.selo", banco: "selo-sala-rn", uf: "RN" },
  { tag: "mg.selo", banco: "selo-sala-mg", uf: "MG" },
  { tag: "rs.selo", banco: "selo-sala-rs", uf: "RS" },
  { tag: "ro.selo", banco: "selo-sala-ro", uf: "RO" },
  { tag: "rr.selo", banco: "selo-sala-rr", uf: "RR" },
  { tag: "se.selo", banco: "selo-sala-se", uf: "SE" },
  { tag: "to.selo", banco: "selo-sala-to", uf: "TO" },
  { tag: "df.selo", banco: "selo-sala-df", uf: "DF" },
  { tag: "mg-parceiros.selo", banco: "selo-sala-mg-parceiros", uf: "MG" },

  //#region selo 2023
  { tag: "rj-2023.selo", banco: "selo-2023-rj", uf: "RJ" },
  { tag: "al-2023.selo", banco: "selo-2023-al", uf: "AL" },
  { tag: "ac-2023.selo", banco: "selo-2023-ac", uf: "AC" },
  { tag: "ms-2023.selo", banco: "selo-2023-ms", uf: "MS" },
  { tag: "ma-2023.selo", banco: "selo-2023-ma", uf: "MA" },
  { tag: "sp-2023.selo", banco: "selo-2023-sp", uf: "SP" },
  { tag: "es-2023.selo", banco: "selo-2023-es", uf: "ES" },
  { tag: "ba-2023.selo", banco: "selo-2023-ba", uf: "BA" },
  { tag: "sc-2023.selo", banco: "selo-2023-sc", uf: "SC" },
  { tag: "ap-2023.selo", banco: "selo-2023-ap", uf: "AP" },
  { tag: "am-2023.selo", banco: "selo-2023-am", uf: "AM" },
  { tag: "ce-2023.selo", banco: "selo-2023-ce", uf: "CE" },
  { tag: "go-2023.selo", banco: "selo-2023-go", uf: "GO" },
  { tag: "mt-2023.selo", banco: "selo-2023-mt", uf: "MT" },
  { tag: "pa-2023.selo", banco: "selo-2023-pa", uf: "PA" },
  { tag: "pb-2023.selo", banco: "selo-2023-pb", uf: "PB" },
  { tag: "pr-2023.selo", banco: "selo-2023-pr", uf: "PR" },
  { tag: "pe-2023.selo", banco: "selo-2023-pe", uf: "PE" },
  { tag: "pi-2023.selo", banco: "selo-2023-pi", uf: "PI" },
  { tag: "rn-2023.selo", banco: "selo-2023-rn", uf: "RN" },
  { tag: "mg-2023.selo", banco: "selo-2023-mg", uf: "MG" },
  { tag: "rs-2023.selo", banco: "selo-2023-rs", uf: "RS" },
  { tag: "ro-2023.selo", banco: "selo-2023-ro", uf: "RO" },
  { tag: "rr-2023.selo", banco: "selo-2023-rr", uf: "RR" },
  { tag: "se-2023.selo", banco: "selo-2023-se", uf: "SE" },
  { tag: "to-2023.selo", banco: "selo-2023-to", uf: "TO" },
  { tag: "df-2023.selo", banco: "selo-2023-df", uf: "DF" },
  { tag: "mg-parceiros-2023.selo", banco: "selo-2023-mg-parceiros", uf: "MG" },
  { tag: "sp-parceiros.selo", banco: "selo-sala-sp-parceiros", uf: "SP" },

  //#endregion

  //sistema selo
  { tag: "rj.sistemaselo", banco: "selo-sala-rj", uf: "RJ" },
  { tag: "al.sistemaselo", banco: "selo-sala-al", uf: "AL" },
  { tag: "ac.sistemaselo", banco: "selo-sala-ac", uf: "AC" },
  { tag: "ms.sistemaselo", banco: "selo-sala-ms", uf: "MS" },
  { tag: "ma.sistemaselo", banco: "selo-sala-ma", uf: "MA" },
  { tag: "sp.sistemaselo", banco: "selo-sala-sp", uf: "SP" },
  { tag: "es.sistemaselo", banco: "selo-sala-es", uf: "ES" },
  { tag: "ba.sistemaselo", banco: "selo-sala-ba", uf: "BA" },
  { tag: "sc.sistemaselo", banco: "selo-sala-sc", uf: "SC" },
  { tag: "ap.sistemaselo", banco: "selo-sala-ap", uf: "AP" },
  { tag: "am.sistemaselo", banco: "selo-sala-am", uf: "AM" },
  { tag: "ce.sistemaselo", banco: "selo-sala-ce", uf: "CE" },
  { tag: "go.sistemaselo", banco: "selo-sala-go", uf: "GO" },
  { tag: "mt.sistemaselo", banco: "selo-sala-mt", uf: "MT" },
  { tag: "pa.sistemaselo", banco: "selo-sala-pa", uf: "PA" },
  { tag: "pb.sistemaselo", banco: "selo-sala-pb", uf: "PB" },
  { tag: "pr.sistemaselo", banco: "selo-sala-pr", uf: "PR" },
  { tag: "pe.sistemaselo", banco: "selo-sala-pe", uf: "PE" },
  { tag: "pi.sistemaselo", banco: "selo-sala-pi", uf: "PI" },
  { tag: "rn.sistemaselo", banco: "selo-sala-rn", uf: "RN" },
  { tag: "mg.sistemaselo", banco: "selo-sala-mg", uf: "MG" },
  { tag: "rs.sistemaselo", banco: "selo-sala-rs", uf: "RS" },
  { tag: "ro.sistemaselo", banco: "selo-sala-ro", uf: "RO" },
  { tag: "rr.sistemaselo", banco: "selo-sala-rr", uf: "RR" },
  { tag: "se.sistemaselo", banco: "selo-sala-se", uf: "SE" },
  { tag: "to.sistemaselo", banco: "selo-sala-to", uf: "TO" },
  { tag: "df.sistemaselo", banco: "selo-sala-df", uf: "DF" },
  {
    tag: "sp-parceiros.sistemaselo",
    banco: "selo-sala-sp-parceiros",
    uf: "SP",
  },
  {
    tag: "ma-parceiros.sistemaselo",
    banco: "selo-sala-ma-parceiros",
    uf: "MA",
  },
  {
    tag: "pe-parceiros.sistemaselo",
    banco: "selo-sala-pe-parceiros",
    uf: "PE",
  },

  //#region sistemaselo 2023
  {
    tag: "mg-parceiros-2023.sistemaselo",
    banco: "selo-2023-mg-parceiros",
    uf: "MG",
  },
  { tag: "rj-2023.sistemaselo", banco: "selo-2023-rj", uf: "RJ" },
  { tag: "al-2023.sistemaselo", banco: "selo-2023-al", uf: "AL" },
  { tag: "ac-2023.sistemaselo", banco: "selo-2023-ac", uf: "AC" },
  { tag: "ms-2023.sistemaselo", banco: "selo-2023-ms", uf: "MS" },
  { tag: "ma-2023.sistemaselo", banco: "selo-2023-ma", uf: "MA" },
  { tag: "sp-2023.sistemaselo", banco: "selo-2023-sp", uf: "SP" },
  { tag: "es-2023.sistemaselo", banco: "selo-2023-es", uf: "ES" },
  { tag: "ba-2023.sistemaselo", banco: "selo-2023-ba", uf: "BA" },
  { tag: "sc-2023.sistemaselo", banco: "selo-2023-sc", uf: "SC" },
  { tag: "ap-2023.sistemaselo", banco: "selo-2023-ap", uf: "AP" },
  { tag: "am-2023.sistemaselo", banco: "selo-2023-am", uf: "AM" },
  { tag: "ce-2023.sistemaselo", banco: "selo-2023-ce", uf: "CE" },
  { tag: "go-2023.sistemaselo", banco: "selo-2023-go", uf: "GO" },
  { tag: "mt-2023.sistemaselo", banco: "selo-2023-mt", uf: "MT" },
  { tag: "pa-2023.sistemaselo", banco: "selo-2023-pa", uf: "PA" },
  { tag: "pb-2023.sistemaselo", banco: "selo-2023-pb", uf: "PB" },
  { tag: "pr-2023.sistemaselo", banco: "selo-2023-pr", uf: "PR" },
  { tag: "pe-2023.sistemaselo", banco: "selo-2023-pe", uf: "PE" },
  { tag: "pi-2023.sistemaselo", banco: "selo-2023-pi", uf: "PI" },
  { tag: "rn-2023.sistemaselo", banco: "selo-2023-rn", uf: "RN" },
  { tag: "mg-2023.sistemaselo", banco: "selo-2023-mg", uf: "MG" },
  { tag: "rs-2023.sistemaselo", banco: "selo-2023-rs", uf: "RS" },
  { tag: "ro-2023.sistemaselo", banco: "selo-2023-ro", uf: "RO" },
  { tag: "rr-2023.sistemaselo", banco: "selo-2023-rr", uf: "RR" },
  { tag: "se-2023.sistemaselo", banco: "selo-2023-se", uf: "SE" },
  { tag: "to-2023.sistemaselo", banco: "selo-2023-to", uf: "TO" },
  { tag: "df-2023.sistemaselo", banco: "selo-2023-df", uf: "DF" },
  //#endregion

  {
    tag: "mg-parceiros.sistemaselo",
    banco: "selo-sala-mg-parceiros",
    uf: "MG",
  },
  {
    tag: "mt-parceiros.sistemaselo",
    banco: "selo-sala-mt-parceiros",
    uf: "MT",
  },

  // agentes territoriais
  { tag: "rj.agentesterritoriais", banco: "agentes-territoriais-rj", uf: "RJ" },
  { tag: "pe.agentesterritoriais", banco: "agentes-territoriais-pe", uf: "PE" },

  // governança empreendedora
  {
    tag: "pe.governancaempreendedora",
    banco: "governanca-empreendedora-pe",
    uf: "PE",
  },

  // territorios
  { tag: "rj.territoriosempreendedores", banco: "rj", uf: "RJ" },
  { tag: "al.territoriosempreendedores", banco: "al", uf: "AL" },
  { tag: "ac.territoriosempreendedores", banco: "ac", uf: "AC" },
  { tag: "ms.territoriosempreendedores", banco: "ms", uf: "MS" },
  { tag: "ma.territoriosempreendedores", banco: "ma", uf: "MA" },
  { tag: "sp.territoriosempreendedores", banco: "sp", uf: "SP" },
  { tag: "es.territoriosempreendedores", banco: "es", uf: "ES" },
  { tag: "ba.territoriosempreendedores", banco: "ba", uf: "BA" },
  { tag: "sc.territoriosempreendedores", banco: "sc", uf: "SC" },
  { tag: "ap.territoriosempreendedores", banco: "ap", uf: "AP" },
  { tag: "am.territoriosempreendedores", banco: "am", uf: "AM" },
  { tag: "ce.territoriosempreendedores", banco: "ce", uf: "CE" },
  { tag: "go.territoriosempreendedores", banco: "go", uf: "GO" },
  { tag: "mt.territoriosempreendedores", banco: "mt", uf: "MT" },
  { tag: "pa.territoriosempreendedores", banco: "pa", uf: "PA" },
  { tag: "pb.territoriosempreendedores", banco: "pb", uf: "PB" },
  { tag: "pr.territoriosempreendedores", banco: "pr", uf: "PR" },
  { tag: "pe.territoriosempreendedores", banco: "pe", uf: "PE" },
  { tag: "pi.territoriosempreendedores", banco: "pi", uf: "PI" },
  { tag: "rn.territoriosempreendedores", banco: "rn", uf: "RN" },
  { tag: "mg.territoriosempreendedores", banco: "mg", uf: "MG" },
  { tag: "rs.territoriosempreendedores", banco: "rs", uf: "RS" },
  { tag: "ro.territoriosempreendedores", banco: "ro", uf: "RO" },
  { tag: "rr.territoriosempreendedores", banco: "rr", uf: "RR" },
  { tag: "se.territoriosempreendedores", banco: "se", uf: "SE" },
  { tag: "to.territoriosempreendedores", banco: "to", uf: "TO" },
  { tag: "df.territoriosempreendedores", banco: "df", uf: "DF" },
  //#endregion

  // Desenvolvimento
  { tag: "rj.desenvolvimentoterritorial", banco: "rj", uf: "RJ", isDT: true },
  { tag: "al.desenvolvimentoterritorial", banco: "al", uf: "AL", isDT: true },
  { tag: "ac.desenvolvimentoterritorial", banco: "ac", uf: "AC", isDT: true },
  { tag: "ms.desenvolvimentoterritorial", banco: "ms", uf: "MS", isDT: true },
  { tag: "ma.desenvolvimentoterritorial", banco: "ma", uf: "MA", isDT: true },
  { tag: "sp.desenvolvimentoterritorial", banco: "sp", uf: "SP", isDT: true },
  { tag: "es.desenvolvimentoterritorial", banco: "es", uf: "ES", isDT: true },
  { tag: "ba.desenvolvimentoterritorial", banco: "ba", uf: "BA", isDT: true },
  { tag: "sc.desenvolvimentoterritorial", banco: "sc", uf: "SC", isDT: true },
  { tag: "ap.desenvolvimentoterritorial", banco: "ap", uf: "AP", isDT: true },
  { tag: "am.desenvolvimentoterritorial", banco: "am", uf: "AM", isDT: true },
  { tag: "ce.desenvolvimentoterritorial", banco: "ce", uf: "CE", isDT: true },
  { tag: "go.desenvolvimentoterritorial", banco: "go", uf: "GO", isDT: true },
  { tag: "mt.desenvolvimentoterritorial", banco: "mt", uf: "MT", isDT: true },
  { tag: "pa.desenvolvimentoterritorial", banco: "pa", uf: "PA", isDT: true },
  { tag: "pb.desenvolvimentoterritorial", banco: "pb", uf: "PB", isDT: true },
  { tag: "pr.desenvolvimentoterritorial", banco: "pr", uf: "PR", isDT: true },
  { tag: "pe.desenvolvimentoterritorial", banco: "pe", uf: "PE", isDT: true },
  { tag: "pi.desenvolvimentoterritorial", banco: "pi", uf: "PI", isDT: true },
  { tag: "rn.desenvolvimentoterritorial", banco: "rn", uf: "RN", isDT: true },
  { tag: "mg.desenvolvimentoterritorial", banco: "mg", uf: "MG", isDT: true },
  { tag: "rs.desenvolvimentoterritorial", banco: "rs", uf: "RS", isDT: true },
  { tag: "ro.desenvolvimentoterritorial", banco: "ro", uf: "RO", isDT: true },
  { tag: "rr.desenvolvimentoterritorial", banco: "rr", uf: "RR", isDT: true },
  { tag: "se.desenvolvimentoterritorial", banco: "se", uf: "SE", isDT: true },
  { tag: "to.desenvolvimentoterritorial", banco: "to", uf: "TO", isDT: true },
  { tag: "df.desenvolvimentoterritorial", banco: "df", uf: "DF", isDT: true },
  {
    tag: "dev-2025.desenvolvimentoTerritorial",
    uf: "AL",
    banco: "ce-dev",
    env: process.env.VUE_APP_BASE_API_2025_CE_DEV,
    isDT: true,
  },
  //#endregion

  { tag: "localhost", banco: "ce-dev", uf: "SC", isDT: true },
];

const ufsDefinitions = ufsPorDefinitions.map((item) => {
  return { ...ufsDefaultDefinitions, ...item };
});

export const EnumAmbienteTipos = {
  prod: "prod",
  dev: "dev",
  hlg: "hlg",
};

let atual;
let hrf = window.location.href;
const ceDevBanco = "ce-dev";
const ceHlgBanco = "ce-hlg";

ufsDefinitions.forEach((item) => {
  if (hrf.includes("sistemaselo")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("selo")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("agentesterritoriais")) {
    item.isAT = true;
  } else if (hrf.includes("governancaempreendedora")) {
    item.isGov = true;
  } else if (hrf.includes("desenvolvimentoterritorial")) {
    item.isDT = true;
  } else {
    item.isCE = true;
  }

  if (item.isSala || item.isParceiro) {
    if (!item.title) item.title = titulos.sala;
    if (!item.corPrimaria) item.corPrimaria = "#DAA520";
    if (!item.logos) item.logos = logoSelo;
  } else if (item.isAT) {
    if (!item.title) item.title = titulos.at;
    if (!item.logos) item.logos = logoAT;

    if (!item.corPrimaria) item.corPrimaria = "#93CE98";
    if (!item.logo) item.logo = "logo_at_branca.png";
  } else if (item.isGov) {
    if (!item.title) item.title = titulos.gov;
    if (!item.logos) item.logos = logoGOV;
    if (!item.logo) item.logo = "Logo_Governança_Empreendedora-branca.png";
    if (!item.corPrimaria) item.corPrimaria = "#9079A8";
  } else if (item.isDT) {
    if (!item.title) item.title = titulos.dt;
    if (!item.logos) {
      item.logos = logoDT;
    }
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else {
    if (!item.logo) item.logo = "logo_nacional.png";
    if (!item.logos) item.logos = logoCE;
    if (!item.title) item.title = titulos.ce;
    if (!item.corPrimaria) item.corPrimaria = "#000";
  }

  if (hrf.includes(item.tag)) {
    // urls com dev no nome
    if (
      item.tag.indexOf("dev") !== -1 ||
      item.tag.indexOf("amazonaws.com") !== -1
    ) {
      console.log(
        "!----------------- AMBIENTE DE DESENVOLVIMENTO -----------------!"
      );

      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_DEV;
      item.ambient = EnumAmbienteTipos.dev;

      if (!item.banco) {
        item.banco = ceDevBanco;
      }
    }
    // urls com hlg no nome
    else if (item.tag.indexOf("hlg") !== -1) {
      console.log(
        "!----------------- AMBIENTE DE HOMOLOGAÇÃO -----------------!"
      );
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_HLG;
      item.ambient = EnumAmbienteTipos.hlg;

      if (!item.banco) {
        item.banco = ceHlgBanco;
      }
      // urls com localhost no nome
    } else if (item.tag.indexOf("localhost") !== -1) {
      if (!item.banco) {
        item.banco = ceDevBanco;
      }
      item.ambient = EnumAmbienteTipos.dev;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_LOCAL;
    }
    // produção
    else {
      console.log("!----------------- AMBIENTE DE PRODUÇÃO -----------------!");
      item.ambient = EnumAmbienteTipos.prod;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_PROD;
    }

    atual = { ...item, urlTag: item.tag };
  }
});

export const atualUfDefinition = atual;

/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
  if (str) {
    if (tipo === "cpf") {
      return str.substring(0, 4) + "**" + str.substring(11, 14);
    } else if (tipo === "telefone") {
      return str.substring(0, 4) + "**" + str.substring(8, 11);
    } else if (tipo === "email") {
      let indexOfArroba = str.indexOf("@", 0);
      let indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
      return (
        str.substring(0, indexOfArrobaDivided) +
        "**" +
        str.substring(indexOfArroba)
      );
    } else if (tipo === "nome") {
      let names = str.split(" ");
      if (names.length > 1) return names[0] + " " + names[names.length - 1];
      return names[0];
    }
  }
  return str;
};

export const sortArrayAsc = (a, b) => {
  if (typeof a === "string" && typeof b === "string") {
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return -1;
    }
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return 1;
    }
  } else {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
  }
  return 0;
};
